import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useController, useFormContext } from 'react-hook-form';
import { Input } from 'rsuite';

import InputWrapper from './InputWrapper';

export const HookFormInput = ({
  name,
  defaultValue = '',
  required = false,
  label = '',
  isTextArea = false,
  isHidden = false,
  largeLabel = false,
  rules = {},
  badgeComponent = null,
  hasCopyButton = false,
  disabled = false,
  upgradePrompt = '',
  boldLabel = false,
  ...rest
}) => {
  // prevents issues where defaultValue is null
  const defaultInputValue = defaultValue || '';
  const { setValue } = useFormContext();
  const {
    field: { onChange, onBlur, value, name: inputName, ref },
    fieldState: { error }
  } = useController({
    name,
    rules: { required, ...rules },
    defaultValue: defaultInputValue,
    shouldUnregister: true,
  });

  useEffect(() => {
    setValue(name, defaultInputValue);
  }, [defaultInputValue]);

  return (
    <InputWrapper
      isHidden={isHidden}
      label={label}
      errorMessage={error?.message}
      largeLabel={largeLabel}
      badgeComponent={badgeComponent}
      inputText={value}
      hasCopyButton={hasCopyButton}
      upgradePrompt={upgradePrompt}
      boldLabel={boldLabel}
      >
      <Input
        onChange={onChange}
        onBlur={onBlur}
        value={value}
        inputRef={ref}
        name={inputName}
        disabled={disabled}
        {...(isTextArea ? { componentClass: 'textarea' } : {})}
        {...(isTextArea ? { rows: 5 } : {})}
        {...rest}
      />
    </InputWrapper>
  );
};

HookFormInput.propTypes = {
  name: PropTypes.string.isRequired,
  defaultValue: PropTypes.string,
  required: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  label: PropTypes.string,
  badgeComponent: PropTypes.element,
  isTextArea: PropTypes.bool,
  largeLabel: PropTypes.bool,
  boldLabel: PropTypes.bool,
  rules: PropTypes.object,
  hasCopyButton: PropTypes.bool,
};

export default HookFormInput;



// WEBPACK FOOTER //
// ./src/components/HookFormInputs/HookFormInput.jsx